<style lang='less'>
    .publicFoot{
        background-color: #E1E1E1;
        width: 100%;
        height: 400px;
        font-size: 16px;
        margin-top: 60px;
        box-sizing: border-box;
        padding: 50px 0;
        position: relative;
        .footContent{
            width: 1440px;
            margin: 0 auto;
            color: #fff;
            display: flex;
            justify-content: space-between;
            >div{
                text-align: left;
                color: #7B7B7B;
                .title{
                    font-size: 15px;
                    margin-bottom: 20px;
                    color: #666666;
                }
                ul{
                    font-size: 14px;
                    color: #666;
                    li{
                        list-style: none;
                        margin-bottom: 16px;
                    }
                }
            }
            .foot_left{
                ul{
                    li{
                        span{
                            display: inline-block;
                            width: 56px;
                        }
                        &.address{
                            display: flex;
                            p{
                                width: 200px;
                                word-wrap: normal;
                            }
                        }
                    }
                }
            }
            .mid{
                ul{
                    li{
                        a{
                            text-decoration: none;
                            color: #7B7B7B;
                            &:hover{
                                color: #333;
                            }
                        }
                    }
                }
            }
        }
        .devBottom{
            color: #AEAEAE;
            font-size: 12px;
            width: 100%;
            height: 50px;
            line-height: 50px;
            background-color: #D2D2D2;
            position: absolute;
            bottom: 0;
            left: 0;
        }
    }
    @media screen and (max-width:500px ){
        .publicFoot{
            display: none;
        }
    }
</style>
<template>
    <div class="publicFoot">
        <div class="footContent">
            <div class="foot_left">
                <div class="title">联系我们</div>
                <ul>
                    <li><span>公司：</span>成都亿格人居科技有限公司</li>
                    <li class="address"><span>地址：</span><p>成都市 新都区龙桥柜柜云仓</p></li>
                </ul>
            </div>
            <div class="mid">
                <div class="title">友情链接</div>
                <ul>
                    <li v-for="item in link" :key="item.name"><a :href="item.url">{{item.name}}</a></li>
                </ul>
            </div>
            <div class="mid">
                <!-- <div class="title"></div> -->
                <ul>
                    <li v-for="item in more" :key="item.name"><a @click="toMore(item.value)">{{item.name}}</a></li>
                </ul>
            </div>
            <div class="foot_right">
                <div class="title">柜柜云仓公众号</div>
                <ul>
                    <li><img width="130" height="130" src="../assets/guigui_factory.jpg" alt=""></li>
                    <li>关注公众号：柜柜云仓</li>
                    <li>手机下单</li>
                </ul>
            </div>
        </div>
        <p class="devBottom"><span style="cursor: pointer;color:#959595" @click="gotoBeian">2010-2020 SiteStar,All Rights Reserved.&nbsp;&nbsp;江苏新格尔人居科技有限公司&nbsp;&nbsp;苏ICP备14034668号-33</span></p>
    </div>
</template>
<script>
export default {
    data(){
        return{
            link:[
                {
                    name:'柜柜下载',
                    url:'https://www.eggrj.com/download.html'
                },
                {
                    name:'柜柜ERP',
                    url:'http://erp.eggi.cn/index.html'
                },
                {
                    name:'模型市场',
                    url:'https://s.eggi.cn/pub/index.html'
                },
                {
                    name:'个人中心',
                    url:'https://www.eggrj.com/person-center/my-wallet.html'
                }
            ],
            more:[
                {
                    name:'包小区',
                    value:'house'
                },
                {
                    name:'测量安装',
                    value:'measureAndInstall'
                }
            ]
        }
    },
    methods:{
        gotoBeian() {
            window.open('https://beian.miit.gov.cn/#/Integrated/index')
        },
        toMore(value){
            this.$router.replace({
              name: value
            })
        },
    }
}
</script>
